import { Canvas } from "@react-three/fiber";
import React, { Suspense, useEffect } from "react";
import { Model } from "./Model";
import "./Book.css";
import { Environment, OrbitControls, Stage } from "@react-three/drei";
import { useTicketStore } from "../../store";
import { useNavigate, useParams } from "react-router";

function Book() {
  let { ticket } = useTicketStore();
  let navigate = useNavigate();
  let { id } = useParams();
  return (
    <div className="forCanvas">
      {ticket > 0 && (
        <button
          className="checkout"
          onClick={() =>
            navigate(`/${id}/payments`
            )
          }
        >
          {"Proceed To Checkout  ->"}
        </button>
      )}

      <Suspense fallback={null}>
        <Canvas
          onCreated={(camera) => {
            camera = { fov: 75, position: [50, 0, 0] };
          }}
        >
          <Stage shadows="contact" environment={null} adjustCamera={0.53}>
            <Model />
            <directionalLight intensity={0.2}/>
          </Stage>
        </Canvas>
      </Suspense>
    </div>
  );
}

export default Book;
